import type { BenefitModalProps } from '../../../../../@types/benefitModalProps';
import { AragModal } from '../aragModal/AragModal';
import SchluesseldienstJpg from './images/key_emergency.png';
import SchluesseldienstWebp from './images/key_emergency.webp';
import SchluesseldienstMobileJpg from './images/key_emergency_mobile.png';
import SchluesseldienstMobileWebp from './images/key_emergency_mobile.webp';
import PhonePng from './images/phone.png';
import PhoneWebp from './images/phone.webp';
import Section3Png from './images/section3.png';
import Section3Webp from './images/section3.webp';
import { InsuranceServiceName } from '@/@types/insurance';

export const Schluesseldienst = ({ isVisible, onClose }: BenefitModalProps) => {
  return (
    <AragModal
      serviceName={InsuranceServiceName.SCHLUESSELDIENST}
      image={SchluesseldienstJpg}
      imageWebp={SchluesseldienstWebp}
      imageMobile={SchluesseldienstMobileJpg}
      imageMobileWebp={SchluesseldienstMobileWebp}
      howItWorksImage1Png={PhonePng}
      howItWorksImage1WebP={PhoneWebp}
      howItWorksImage2Png={Section3Png}
      howItWorksImage2WebP={Section3Webp}
      isVisible={isVisible}
      onClose={onClose}
    />
  );
};

export default Schluesseldienst;
